import React from 'react';
import { EmployeeDemographicReportIcon } from '@common-fe/common-fe';

import { ROUTES } from '@/common';

import { useFavoriteReportHandler } from '../hooks';
import { ReportTypeKeys } from '../report.types';

import ReportCardBase, { ReportCardBaseProps } from './ReportCardBase';
interface Props extends ReportCardBaseProps {}
const TEST_ID = 'employee-demographic-report-card';
const EmployeeDemographicCard: React.FC<Props> = ({ isFavoriteMode }) => {
  const { isFavorite, handleToggleReportKey } = useFavoriteReportHandler(ReportTypeKeys.EmployeeDemographic);
  return (
    <ReportCardBase
      // isNew
      testId={TEST_ID}
      isWideMode={isFavoriteMode}
      url={ROUTES.EMPLOYEE_DEMOGRAPHIC_REPORT}
      isFavorite={isFavorite}
      onChangeFavorite={handleToggleReportKey}
      icon={
        <EmployeeDemographicReportIcon
          size={isFavoriteMode ? '50px' : '40px'}
          color={isFavoriteMode ? 'iconAccent' : 'iconDisabled'}
        />
      }
      title="Employee Demographics"
      description="View employees demographic details
including contact information"
    />
  );
};
export default EmployeeDemographicCard;
